import { useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes, matchPath, useLocation } from 'react-router';
import { Navigate } from 'react-router-dom';
import { UncaughtError } from 'src/components/base/UncaughtError';
import { Modals } from './Modals';
import { Pages } from './Pages';
import { routes } from './paths';

const modalRoutes = [
  {
    path: routes.dashboard.board.rowDialog({
      board: ':boardId',
      row: ':rowId',
      table: ':tableId',
    }),
  },
  {
    path: routes.dashboard.chat.newThread(
      ':conversationKey',
      ':parentMessageId',
    ),
  },
  {
    path: routes.dashboard.chat.thread(
      ':rootConversationKey',
      ':conversationKey',
    ),
  },
  {
    path: routes.dashboard.docs.comments(':docId'),
  },
];

export const Router = () => {
  const location = useLocation();
  const background = location.state?.background;

  const isModalRoute = useMemo(
    () => modalRoutes.some((route) => matchPath(route, location.pathname)),
    [location.pathname],
  );

  return (
    <ErrorBoundary FallbackComponent={UncaughtError}>
      <Pages location={background || location} />
      {isModalRoute && <Modals />}
      {/* Prevent Router from redirect when access a modal route using a direct link */}
      {background && !isModalRoute && (
        <Routes>
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      )}
    </ErrorBoundary>
  );
};
